module.exports = __webpack_public_path__ + "img/pic-04.86386334.png";